// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__gi-ux","content":"LandingPage_content__uHA10"};